<template>
  <div class="relative z-1">
    <saving-overlay
      :label="i18n.saving"
      v-if="saving"
      class="rounded-r rounded-bl"
    ></saving-overlay>
    <form @submit.prevent="save" class="p-5">
      <simple-input
        :label="i18n.password"
        :label-info="i18n.at_least"
        v-model="form.password"
        name="password"
        :required="true"
        type="password"
      ></simple-input>
      <simple-input
        :label="i18n.password_confirmation"
        v-model="form.password_confirmation"
        name="password_confirmation"
        :required="true"
        type="password"
      ></simple-input>

      <div class="flex items-center justify-end">
        <ranch-button
          type="submit"
          :label="i18n.save"
          icon="save"
        ></ranch-button>
      </div>
    </form>
  </div>
</template>

<script>
import { flash, handleAxiosError } from "@/boot/functions";

import { Form } from "../../../Utilities/Form";
import { mapState } from "vuex";
import SavingOverlay from "../../../Design/Forms/SavingOverlay";
import SimpleInput from "../../../Design/Forms/SimpleInput";

export default {
  props: [],
  components: { SimpleInput, SavingOverlay },
  mixins: [],
  data: function () {
    return {
      saving: false,
      saved: false,
      form: new Form({
        password: null,
        password_confirmation: null,
      }),
    };
  },
  methods: {
    save() {
      this.saving = true;
      this.form
        .post(this.endpoint)
        .then(() => {
          this.saving = false;
          this.saved = true;
          flash(this.i18n.saved, "success");
        })
        .catch(handleAxiosError)
        .then(() => {
          this.saving = false;
        });
    },
  },
  computed: {
    ...mapState({
      i18n: (state) => state.account.i18n.settings.password.form,
    }),
    endpoint() {
      return this.$store.state.account.routes.password;
    },
  },
  mounted() {},
};
</script>

<style></style>
